import { Icons } from '../../components/Icons/Icons';
import { useEffect } from 'react';
import { getTranslation } from '../../constants/translations';

import './Hero.scss';
import { getDefinedRegion } from '../../helpers/getRegion';

export const Hero = () => {
  const t = getTranslation();
  const domen = getDefinedRegion();

  useEffect(() => {
    const hero = document.getElementById('hero') as HTMLElement;

    window.setTimeout(() => {
      hero.style.zIndex = '1';
    }, 1500);
  }, []);

  return (
    <section className={`hero hero--${domen} main__hero`} id="hero">
      <div className="hero__container">
        <h1 className="hero__title">Sixtix</h1>
        <div className="hero__arrow-container">
          {window.screen.width < 990 ? (
            <Icons name="arrow-circle" customClassName="hero__main-arrow" />
          ) : (
            <Icons name="arrow-short" customClassName="hero__main-arrow" />
          )}
        </div>
        <div
          className="hero__sub-title"
          dangerouslySetInnerHTML={{ __html: t.HERO.subtitleHTML }}
        ></div>
      </div>
    </section>
  );
};
